import { Vue } from 'vue-property-decorator';
export const Eventbus = new Vue();
